import { Component, HostListener, inject, OnInit, signal } from '@angular/core';
import { SocialScreeningService } from '../../../../services/social-screening/social-screening.service';
import { AlertService } from '../../../../atoms/alert/alert.service';
import { RecruitGroupResponseDto } from '../../../../common/general-types/recruit-groups.dto';
import { RecruitGroupService } from '../../../../services/recruit-group/recruit-group.service';
import { LoadingInlineComponent } from '../../../../atoms/loading-inline/loading-inline.component';
import { LdgImgComponent } from '../../../../atoms/ldg-img/ldg-img.component';
import { ImageService } from '../../../../services/image/image.service';
import { FormatService } from '../../../../common/format/format.service';
import { DecimalPipe } from '@angular/common';
import { CreatorResponseDto } from '../../../../common/general-types/creators.dto';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { ToastNotificationService } from '../../../../atoms/toast-notification/toast-notification.service';
import { BriefService } from '../../../../services/brief/brief.service';
import { ViewportOverlayDirective } from '../../../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'sb-creators-for-list',
  standalone: true,
  imports: [LoadingInlineComponent, LdgImgComponent, DecimalPipe],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './creators-for-list.component.html',
  styleUrl: './creators-for-list.component.css'
})
export class CreatorsForListComponent implements OnInit {

  ngOnInit(): void {
    this.getSocialScreeningBriefs();
  }

  @HostListener('document:keydown.escape', ['$event' as any])
  handleEscapeKey(event: KeyboardEvent) {
    this.closeCreatorsForList();
  }


  selectedScreeningList = signal<RecruitGroupResponseDto | undefined>(undefined);
  specificScreeningList = signal<RecruitGroupResponseDto | undefined>(undefined);
  confirmAddToScreening = signal<boolean>(false);

  isProcessingInvites = signal<boolean>(false);
  /**
   * Creator groups. Recruit groups are the only creator-collection construct now — the
   * standalone screening lists this drawer used to read were consolidated into them.
   */
  allLists = signal<RecruitGroupResponseDto[]>([]);
  displayScreeningLists = signal<RecruitGroupResponseDto[] | undefined>(undefined);



  /** Services */
  public socialScreeningService = inject(SocialScreeningService);
  public alertService = inject(AlertService);
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  private currentUserService = inject(CurrentUserService);
  private toastNotificationService = inject(ToastNotificationService);
  private briefService = inject(BriefService);
  private recruitGroupService = inject(RecruitGroupService);
  /** Services - END */


  getSocialScreeningBriefs() {
    this.getSocialScreeningLists();
  }

  getSocialScreeningLists() {
    this.recruitGroupService.initRecruitmentGroups().then(() => {
      const groups = this.recruitGroupService.visibleGroups();
      this.allLists.set(groups);
      this.displayScreeningLists.set(groups);
    });
  }


  selectList(list: RecruitGroupResponseDto) {
    this.selectedScreeningList.set(list);
    this.specificScreeningList.set(list);
  }


  addToList() {
    console.log('addToList()');
    console.log('selectedScreeningList(): ', this.selectedScreeningList());
    console.log('creators(): ', this.socialScreeningService.selectedCreators());

    if (this.selectedScreeningList() && this.socialScreeningService.selectedCreators() && this.socialScreeningService.selectedCreators().length > 0) {
      this.confirmAddToScreening.set(true);
    } else {
      this.alertService.alert({
        title: 'Missing Information',
        message: 'Please select a screening list and creators to add to the list.',
        type: 'alert',
        icon: 'info',
        confirmText: 'OK',
        cancelText: 'Cancel'
      });
    }
  }

  confirmAddToScreeningList() {
    console.log('confirmAddToScreeningList()');

    this.isProcessingInvites.set(true);

    const creatorIds = this.socialScreeningService.selectedCreators()
      .map((creator) => creator.blazeFirebaseUid)
      .filter((id): id is string => !!id);

    // Adding to the group also enrols these creators in every brief backed by it — for a
    // screening brief that is what actually starts the screen.
    this.recruitGroupService.addCreatorsToGroup(this.selectedScreeningList()!.id, creatorIds).subscribe({
      next: (result) => {
        this.isProcessingInvites.set(false);
        this.confirmAddToScreening.set(false);
        this.socialScreeningService.selectedCreators.set([]);
        this.briefService.creatorsToScreen.set([]);
        this.toastNotificationService.alert({
          title: 'Creators added to group',
          message: `${result.added.length} creator${result.added.length === 1 ? '' : 's'} added to ${this.selectedScreeningList()?.groupName}.`
            + (result.noodleSyncFailed ? ' They were saved, but could not be synced for screening yet — contact support to resync this group.' : ''),
          type: 'success',
          icon: 'success'
        });
        this.closeCreatorsForList();
      },
      error: () => {
        this.isProcessingInvites.set(false);
        this.toastNotificationService.alert({
          title: 'Whoops! Something went wrong.',
          message: 'The creators could not be added. Please try again.',
          type: 'error',
          icon: 'error'
        });
      },
    });
  }


  async clearSelection() {
    const confirm = await this.alertService.confirm({
      title: 'Clear Selection?',
      message: 'Are you sure you want to clear the selection?',
      confirmText: 'Clear Selection',
      cancelText: 'Cancel',
      type: 'confirm',
      icon: 'info'
    });

    if (confirm) {
      this.socialScreeningService.selectedCreators.set([]);
      this.briefService.creatorsToScreen.set([]);
      this.closeCreatorsForList();
    }
  }

  closeCreatorsForList() {
    this.socialScreeningService.showToBeScreeneed.set(false);
  }

  removeSelectedCreator(creator: CreatorResponseDto): void {
    this.socialScreeningService.removeCreator(creator);
    this.briefService.creatorsToScreen.set(
      this.briefService.creatorsToScreen().filter(
        (application) => application.creator?.blazeFirebaseUid !== creator.blazeFirebaseUid,
      ),
    );
  }



  getAvgEngaegement(creator: CreatorResponseDto) {
    if (creator && creator.ssCreator) {
      if (creator.ssCreator.instagramAverages && creator.ssCreator.tiktokAverages) {
        return ((creator.ssCreator.instagramAverages?.averageEngagementRate || 0) + (creator.ssCreator.tiktokAverages?.averageEngagementRate || 0)) / 2
      } else if (creator.ssCreator.instagramAverages) {
        return (creator.ssCreator.instagramAverages?.averageEngagementRate || 0)
      } else if (creator.ssCreator.tiktokAverages) {
        return (creator.ssCreator.tiktokAverages?.averageEngagementRate || 0)
      } else {
        return 0
      }
    } else {
      return 0
    }
  }
}
